import { render, staticRenderFns } from "./mine_tz.vue?vue&type=template&id=2db65988&scoped=true&"
import script from "./mine_tz.vue?vue&type=script&lang=js&"
export * from "./mine_tz.vue?vue&type=script&lang=js&"
import style0 from "./mine_tz.vue?vue&type=style&index=0&id=2db65988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db65988",
  null
  
)

export default component.exports